var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 128,
    viewBox: "0 0 216 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 128,
    rx: 8,
    fill: "#F9F9FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_800_72274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.649 98.6496L121.299 77.2996L111.884 67.8846L83.4991 39.4996L78.5641 34.5646L73.3491 29.3496L68.4141 34.2846L76.4991 42.4046V88.4996C76.4991 92.3496 79.6491 95.4996 83.4991 95.4996H129.594L137.679 103.585L142.649 98.6496ZM83.4991 88.4996V49.4046L107.439 73.3446L104.499 77.0196L97.4991 67.4996L86.9991 81.4996H115.594L122.594 88.4996H83.4991ZM93.4041 39.4996L86.4041 32.4996H132.499C136.349 32.4996 139.499 35.6496 139.499 39.4996V85.5946L132.499 78.5946V39.4996H93.4041Z",
    fill: "#DADEE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_800_72274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white",
    transform: "translate(66 22)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNotFound);
export default __webpack_public_path__ + "static/media/imgNotFound.760950cbaed9870f359a90fc1dacf58c.svg";
export { ForwardRef as ReactComponent };